import { useLocation, useNavigate } from 'react-router-dom';
import { fetchApiData } from '../Utils/ApiCalls';
import { SIGNOUT_ENDPOINT } from '../urls';
import InitialIcon from './InitialIcon';
import useFormStatus from '../Hooks/useFormStatus';
import { useEffect, useState } from 'react';
import LoaderCircle from './LoaderCircle';
import { ReactComponent as Logo } from '../Icons/attentive-logo.svg';
import { StyleProvider, Tab, Tabs } from '@attentive-platform/stem-ui';
import { isBeamUser } from '../Utils/HelperFunctions';
import { Navigation, BeamNavigation } from '../Constants/Constants';

const Navbar = ({ setIsLoggedIn }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { handleApiResult } = useFormStatus();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(0);

  const email = localStorage.getItem('userEmail');
  const initialLetter = email && email.charAt(0).toUpperCase();
  const beamUser = isBeamUser();

  const handleSignout = async event => {
    event.preventDefault();
    setLoading(true);
    const response = await fetchApiData({
      endpoint: SIGNOUT_ENDPOINT,
      apiRequest: 'POST'
    });
    handleApiResult(response);
    localStorage.clear();
    sessionStorage.clear();
    setIsLoggedIn(false);
    setLoading(false);
    navigate('/login');
  };

  const currentNavigation = beamUser ? BeamNavigation : Navigation;

  const handleChange = (event, newValue) => {
    setValue(newValue);
    navigate(currentNavigation[newValue]);
  };

  // Set initial navigation
  useEffect(() => {
    setValue(0);
    navigate(currentNavigation[0]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Update tab value based on current location
  useEffect(() => {
    const navigationEntry = Object.entries(currentNavigation).find(([_, path]) => location.pathname === path);

    if (navigationEntry) {
      setValue(parseInt(navigationEntry[0]));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const getTabsBasedOnUser = () => {
    return [
      <Tab key='dashboard' label='CSM Dashboard' className='p-2' />,
      ...(!beamUser ? [<Tab key='operations' label='Operations' className='p-2' />] : []),
      <Tab key='companies' label='Companies' className='p-2' />,
      ...(!beamUser ? [<Tab key='enterprise' label='Enterprise Contract Dashboard' className='p-2' />] : []),
      ...(beamUser ? [<Tab key='bpt' label='BPT' className='p-2' />] : []),
      ...(!beamUser ? [<Tab label='Coupons' className='p-2' />] : []),
      ...(!beamUser ? [<Tab label='Promotional Program' className='p-2' />] : []),
      ...(beamUser ? [<Tab label='Rosetta' className='p-2' />] : [])
    ];
  };

  return (
    <div>
      <div className='flex w-full h-16 justify-between items-center p-4'>
        <a href='/'>
          {beamUser ? (
            <img
              src='https://storage.googleapis.com/falcon-shared-images-front-end/assets/svgs/attentive-logos/beamai.svg'
              className='w-[136px] h-[43px]'
              alt='beam logo'
            />
          ) : (
            <Logo />
          )}
        </a>
        {email && (
          <div className='flex items-center pr-2 gap-2'>
            <a className='cursor-pointer mb-0' data-toggle='tooltip' title={email} href='/'>
              <InitialIcon initials={initialLetter || ''} />
            </a>
            <div className='text-base font-medium text-[#F44A3E] cursor-pointer' onClick={handleSignout}>
              Log Out
              {loading && <LoaderCircle />}
            </div>
          </div>
        )}
      </div>
      {email && (
        <div className='flex bg-white justify-between shadow-md px-8 items-center'>
          <div>
            <StyleProvider theme={beamUser ? 'default' : 'attentive-internal'}>
              <Tabs value={value} textColor='primary' indicatorColor='primary' onChange={handleChange}>
                {getTabsBasedOnUser()}
              </Tabs>
            </StyleProvider>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
